// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { customProfileFieldTypeGuard, customProfileFieldConfigGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    type: customProfileFieldTypeGuard,
    label: z.string().min(1).max(128).optional(),
    description: z.string().max(256).nullable().optional(),
    required: z.boolean().optional(),
    config: customProfileFieldConfigGuard.optional(),
    createdAt: z.number().optional(),
    sieOrder: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    type: customProfileFieldTypeGuard,
    label: z.string().max(128),
    description: z.string().max(256).nullable(),
    required: z.boolean(),
    config: customProfileFieldConfigGuard,
    createdAt: z.number(),
    sieOrder: z.number(),
});
export const CustomProfileFields = Object.freeze({
    table: 'custom_profile_fields',
    tableSingular: 'custom_profile_field',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        name: 'name',
        type: 'type',
        label: 'label',
        description: 'description',
        required: 'required',
        config: 'config',
        createdAt: 'created_at',
        sieOrder: 'sie_order',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'name',
        'type',
        'label',
        'description',
        'required',
        'config',
        'createdAt',
        'sieOrder',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
